import Message from '../views/messages/Index.vue';
import { checkauth } from '../Helper';

// inserimento, modifica e dettaglio sono pagine: tornando indietro la lista riparte dal suo URL
const MessageCreate = () => import('../views/messages/Create.vue');
const MessageEdit = () => import('../views/messages/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/messages',
		name: 'messages',
		component: Message,
		beforeEnter: auth,
	},
	{
		path: '/messages/new',
		name: 'message-new',
		component: MessageCreate,
		beforeEnter: auth,
	},
	// :id e' l'_id della comunicazione (24 caratteri esadecimali): "new" non puo' mai finire qui
	{
		path: '/messages/:id([0-9a-fA-F]{24})',
		name: 'message-edit',
		component: MessageEdit,
		beforeEnter: auth,
	},
];
